<template>
  <footer class="footer footer-big">
    <div class="container">
      <div class="content">
        <div class="md-layout md-alignment-top-space-between">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <h5 class="text-primary bold">{{ $t("Organizer") }}</h5>
            <hr class="text-primary" />
            <div class="md-layout text-gray">
              <div class="md-layout-item md-size-75">
                <div>{{ $t("DATA_ISW.name") }}</div>
                <div>{{ $t("DATA_ISW.street") }}</div>
                <div>{{ $t("DATA_ISW.city") }}</div>
              </div>
              <div class="md-layout-item md-size-25 md-xsmall-size-40">
                <div>
                  <a class="text-gray" href="mailto:forum@isw.org.pl"
                    >forum@isw.org.pl</a
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-20 md-small-size-100"></div>

          <div class="md-layout-item md-size-30 md-small-size-100 text-gray">
            <h5 class="text-primary bold">{{ $t("Technical partner") }}</h5>
            <hr class="text-primary" />
            <div class="md-layout md-alignment-top-space-between">
              <div class="md-layout-item technical-partner">
                <div class="technical-partner-logo-container">
                  <img
                    class="technical-partner-logo"
                    src="@/assets/img/logo.196ee4df.png"
                  />
                </div>
                <div class="technical-partner-data">
                  <div class="text-gray">Kontur.IT</div>
                  <div class="technical-partner-site-container">
                    <i class="fas fa-globe"></i> -
                    <a
                      href="https://kontur.it"
                      target="_blank"
                      class="text-gray"
                      >https://kontur.it</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 text-center">
            <hr />
            <h5 class="text-primary bold" style="text-align: right !important;">
              <i style="margin-right:7px; margin-left: 7px;" class="fas fa-book fa-sm"></i>
              <a href="Terms">Regulamin serwisu</a>
              &nbsp;|&nbsp;
              <i style="margin-right:7px; margin-left: 7px" class="fas fa-book fa-sm"></i>
              <a href="Privacy">Polityka prywatności</a>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
.footer-big {
  padding: 20px 0px 40px 0px;
  margin-top: 20px;
}

.technical-partner {
  width: 100%;
  display: flex;
  gap: 20px;
}

.technical-partner-logo-container {
  width: 45%;
  max-width: 150px;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.technical-partner-site-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.technical-partner-site-container a {
  font-size: 12px;
}

.technical-partner .technical-partner-logo {
  width: 100%;
}

.technical-partner .technical-partner-data {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
</style>
